// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__1lagr","Icon":"Controls_Icon__2Ucoj"};